import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { icons } from "./svg.js";
const Icon = ({ className = '', color = '', height = 20, margin, name, scheme = 'dark', style = {}, width = 20, }) => {
    const schemeClasses = {
        dark: 'icon-dark',
        light: 'icon-light',
    };
    const classes = ['icon', color ? '' : schemeClasses[scheme], className]
        .filter(Boolean)
        .join(' ');
    const svgStyle = {
        height: `${height}px`,
        width: `${width}px`,
        ...(color ? { color, fill: color } : {}),
    };
    const containerStyle = {
        ...style,
        ...(margin ? { margin } : {}),
    };
    return (_jsx("div", { className: classes, style: Object.keys(containerStyle).length > 0
            ? containerStyle
            : undefined, children: React.cloneElement(icons[name], {
            style: svgStyle,
        }) }));
};
export default Icon;
//# sourceMappingURL=icon.js.map